import React, { useState, useRef } from 'react';
import { history } from 'umi';
import LabelModalStyled from './LabelModalStyled';
import Label1 from '@/assets/img/label1.png';
// import Label2 from '@/assets/img/label2.png';
import Label3 from '@/assets/img/label3.png';
import Label4 from '@/assets/img/label4.png';
// import Label5 from '@/assets/img/label5.png';
import Label6 from '@/assets/img/label6.png';
import {
  Box,
  RadioGroup,
  FormControlLabel,
  Radio,
  Button,
} from '@material-ui/core';
import webStorage from '@/utils/storageManager';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';

const LabelModal = (props) => {
  const sureRfe = useRef();
  const [chooseLabel, setChooseLabel] = useState('label1');
  // 字典项
  let TAG_TYPE = webStorage.get('DICTOBJ')?.TAG_TYPE || [];
  TAG_TYPE.sort((a, b) => a.sort - b.sort);
  TAG_TYPE.forEach((item) => {
    if (item.dictValue === 1) {
      item.imgSrc = Label1;
      item.value = 'label1';
      item.content =
        '自定义标签的每个值的名称以及计算规则，划分出多个等级和区间';
    } else if (item.dictValue === 234) {
      item.imgSrc = Label3;
      item.value = 'label2';
      item.content =
        '将用户完成事项的指标数 值通过相应计算后得到的数值作 为标签值';
    } else if (item.dictValue === 6) {
      item.imgSrc = Label6;
      item.value = 'label6';
      item.content = '使用上传文件的结果作为标签值，为客户进行标识';
    } else if (item.dictValue === 5) {
      item.imgSrc = Label4;
      item.value = 'label4';
      item.content = '通过SQL，将复杂逻辑的计算结果作为标签值';
    }
  });

  const handleCreateLabel = () => {
    const routeMap = new Map([
      ['label1', { pathname: '/profile/label_manage/collection_label' }],
      [
        'label4',
        {
          pathname: '/profile/label_manage/sql',
          query: { chooseLabel: 'sqlLabel', type: '5' },
        },
      ],
      [
        'label6',
        {
          pathname: '/profile/label_manage/import',
          query: { chooseLabel: 'importlabel', type: '6' },
        },
      ],
      [
        'label5',
        {
          pathname: '/profile/label_manage/text',
          query: { chooseLabel: 'textLabel', type: '2' },
        },
      ],
      [
        'label3',
        {
          pathname: '/profile/label_manage/math',
          query: { chooseLabel: 'mathLabel', type: '3' },
        },
      ],
      [
        'label2',
        {
          pathname: '/profile/label_manage/statistics',
          query: { chooseLabel: 'statistics', type: '234' }, //statistics
        },
      ],
    ]);
    window.NE_DAWN.trigger(sureRfe.current, {
      event: '_ec', // 事件名
      params: { ...routeMap.get(chooseLabel).query }, // 事件公参
    });
    webStorage.delete('DELETE_TAG');
    history.push({
      pathname: routeMap.get(chooseLabel).pathname,
      query: routeMap.get(chooseLabel).query,
    });
  };

  // 选中卡片
  const handleChoose = (item) => {
    window.NE_DAWN.trigger(sureRfe.current, {
      event: '_ec', // 事件名
      params: {
        initUrl: window.location.origin + window.location.pathname,
      }, // 事件公参
    });
    setChooseLabel(item.value);
  };

  return (
    <LabelModalStyled>
      <div
        data-log={JSON.stringify({
          oid: 'modal_user_profile_label_management_edit_create_label_type_select',
          isPage: true,
          params: {
            initUrl: window.location.origin + window.location.pathname,
          },
          events: ['_pv', '_pd'],
        })}
      >
        <RadioGroup
          aria-label="gender"
          defaultValue="label1"
          name="radio-buttons-group"
          className="label-list-wrap"
          value={chooseLabel}
          onChange={(e) => {
            setChooseLabel(e.target.value);
            // return pr.onChange(e.target.value);
          }}
        >
          {TAG_TYPE &&
            TAG_TYPE?.map((item) => (
              <Box
                className={
                  item.value === chooseLabel
                    ? 'isChosen label-content'
                    : 'label-content'
                }
                onClick={() => handleChoose(item)}
              >
                <FormControlLabel
                  value={item.value}
                  control={<Radio />}
                  label=""
                />
                <img src={item.imgSrc} alt="" srcset="" />
                <div className="label-title-wrap">
                  <span className="label-title">{item.nameZh}</span>
                  <span className="label-title-content">{item.content}</span>
                </div>
              </Box>
            ))}
        </RadioGroup>
        {/* 取消按钮 */}
        <div className="label-btn-wrap">
          <Button
            onClick={props.handleCancelLabel}
            startIcon={<CloseIcon sx={{ width: '14px', height: '14px' }} />}
            variant="contained"
            color="secondary"
          >
            取消
          </Button>
          <Button
            ref={sureRfe}
            startIcon={<CheckIcon className="icon-font-size" />}
            variant="contained"
            onClick={() => handleCreateLabel()}
          >
            确认
          </Button>
        </div>
      </div>
    </LabelModalStyled>
  );
};

export default LabelModal;
